// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xsJk","colBig":"styles_colBig__1uhyY","colSmall":"styles_colSmall__2eSgP"};